module.exports = __webpack_public_path__ + "img/coins.299ebcf4.svg";